import React from "react";
const DashboardHeader = () => {
  const user = sessionStorage.getItem("user");
  const subscriberName = sessionStorage.getItem("subscriberName");
  const data = JSON.parse(user);
  return (
    <div className="flex items-center justify-between">
      <div>
        <h1 className="text-2xl font-semibold text-black">
          {" "}
          Hello, {subscriberName ? subscriberName : data.first_name}
        </h1>
        <p className="text-base text-neutral-500">
          Track all your investment easily at one place
        </p>
      </div>
    </div>
  );
};

export default DashboardHeader;
